export default [
  {
    path: '/ci/received',
    name: 'ci_received',
    component: () => import('./ReceivedCi.vue'),
    meta: {
      pageSection: 'Comunicação interna',
      pageTitle: 'CI - Recebidas',
      auth: true,
      user: 'Admin',
    },
  },
]
